import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon, LockIcon, MailIcon } from 'lucide-react';
import { useApp } from '../contexts/AppContext';
import { Logo, Waves } from '../components/ui/Logo';
import { Button } from '../components/ui/Button';
import { inputClass } from '../components/ui/Field';
import { DEMO_ADMIN, DEMO_CLAN, DEMO_GOST } from '../data/members';
import type { Role } from '../types';
const profili: {
  role: Role;
  memberId: string;
  ime: string;
  opis: string;
  email: string;
}[] = [{
  role: 'clan',
  memberId: DEMO_CLAN,
  ime: 'Judita Volčanšek',
  opis: 'Aktivna članica · 1. sopran',
  email: 'judita.volcansek@mepz-viva.si'
}, {
  role: 'gost',
  memberId: DEMO_GOST,
  ime: 'Veronika Strnad',
  opis: 'Gostujoča članica · 2. sopran',
  email: 'veronika.strnad@mepz-viva.si'
}, {
  role: 'vodstvo',
  memberId: DEMO_ADMIN,
  ime: 'Krištof Strnad',
  opis: 'Dirigent · vodstvo zbora',
  email: 'kristof.strnad@mepz-viva.si'
}];
export function Login() {
  const {
    login,
    settings
  } = useApp();
  const navigate = useNavigate();
  const [izbran, setIzbran] = useState(0);
  const [geslo, setGeslo] = useState('••••••••');
  const [email, setEmail] = useState(profili[0].email);
  const profil = profili[izbran];
  function izberi(i: number) {
    setIzbran(i);
    setEmail(profili[i].email);
  }
  function submit(e: React.FormEvent) {
    e.preventDefault();
    login(profil.role, profil.memberId);
    navigate(profil.role === 'vodstvo' ? '/admin' : '/clan');
  }
  return <div className="flex min-h-full w-full flex-col bg-white lg:flex-row" data-id="element-1280" data-mp="3k5py9af49ys5">
      <div className="relative flex flex-col justify-between overflow-hidden bg-green-700 px-6 py-10 lg:w-[44%] lg:px-14 lg:py-14" data-id="element-1281" data-mp="3k4yc0q7etdej">
        <Waves className="absolute inset-x-0 top-1/3 h-56 w-full" color="#ffffff" opacity={0.18} data-id="element-1282" data-mp="1prf9f1yiv4md" />
        <div className="relative" data-id="element-1283" data-mp="1ksvl4uwghgqu">
          <Logo variant="dark" className="h-14 lg:h-16" data-id="element-1284" data-mp="1ktnf61aen6f0" />
        </div>
        <div className="relative mt-10 lg:mt-0" data-id="element-1285" data-mp="2ah9epnmge8he">
          <h1 className="max-w-sm text-2xl font-semibold leading-snug text-white lg:text-3xl" data-id="element-1286" data-mp="2aikhpl82rc7g">
            Interni portal zbora VIVA Brežice
          </h1>
          <p className="mt-3 max-w-sm text-[15px] leading-relaxed text-green-50/85" data-id="element-1287" data-mp="2jgwek4zjb68c">
            Vaje, nastopi, prisotnost, obvestila in gradiva — vse na enem mestu, za člane in vodstvo.
          </p>
          <p className="mt-8 text-sm italic text-green-100/80" data-id="element-1288" data-mp="2tgezoor6ky1z">{settings.slogan}</p>
        </div>
      </div>

      <div className="flex flex-1 items-center justify-center px-6 py-12 lg:px-10" data-id="element-1289" data-mp="2xg5lee1uonzn">
        <div className="w-full max-w-sm" data-id="element-1290" data-mp="327fbffrb9tc2">
          <h2 className="text-xl font-semibold text-ink" data-id="element-1291" data-mp="328pb29dtb9kt">Prijava</h2>
          <p className="mt-1 text-sm text-ink-muted" data-id="element-1292" data-mp="375ywldy2z13d">Vpišite se s svojim zborovskim e-naslovom.</p>

          <form onSubmit={submit} className="mt-7 space-y-4" data-id="element-1293" data-mp="3c7655f81s4b3">
            <div data-id="element-1294" data-mp="3h57o805h43mk">
              <label htmlFor="email" className="mb-1.5 block text-[13px] font-medium text-ink" data-id="element-1295" data-mp="3h4ohlfl9x1nu">
                E-naslov
              </label>
              <div className="relative" data-id="element-1296" data-mp="15jfgr98sdivw">
                <MailIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-muted" data-id="element-1297" data-mp="10j1b1xunql11" />
                <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className={`${inputClass} pl-9`} data-id="element-1298" data-mp="vivgo9x06kf9" />
              </div>
            </div>

            <div data-id="element-1299" data-mp="1j8ppmge7bou8">
              <label htmlFor="geslo" className="mb-1.5 block text-[13px] font-medium text-ink" data-id="element-1300" data-mp="1jaakk74fh9sm">
                Geslo
              </label>
              <div className="relative" data-id="element-1301" data-mp="1egg3lbg7j8x8">
                <LockIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-muted" data-id="element-1302" data-mp="19jzi6p0e78nu" />
                <input id="geslo" type="password" value={geslo} onChange={e => setGeslo(e.target.value)} className={`${inputClass} pl-9`} data-id="element-1303" data-mp="26zvdniuapnfm" />
              </div>
            </div>

            <div className="flex items-center justify-between pt-1" data-id="element-1304" data-mp="1rpgmyomepd4x">
              <label className="flex items-center gap-2 text-[13px] text-ink-muted" data-id="element-1305" data-mp="1crxrl3f841oi">
                <input type="checkbox" defaultChecked className="h-4 w-4 rounded border-line accent-green-500" data-id="element-1306" data-mp="1cuafrybkr8a0" />
                Ostani prijavljen
              </label>
              <button type="button" className="text-[13px] font-medium text-green-600 hover:underline" data-id="element-1307" data-mp="25h3lyw7qgzre">
                Pozabljeno geslo?
              </button>
            </div>

            <Button type="submit" full size="lg" className="mt-2" data-id="element-1308" data-mp="1vpqtq3i0w7ku">
              Prijava
              <ArrowRightIcon className="h-4 w-4" data-id="element-1309" data-mp="20p3fsm12lamd" />
            </Button>
          </form>

          <div className="mt-8 border-t border-line pt-6" data-id="element-1310" data-mp="2oexrh09nkt51">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-muted" data-id="element-1311" data-mp="2odcwxanc9a76">
              Predstavitveni profili
            </p>
            <div className="mt-3 space-y-2" data-id="element-1312" data-mp="hqf9fp0cuk27">
              {profili.map((p, i) => <button key={p.memberId} type="button" onClick={() => izberi(i)} aria-pressed={izbran === i} className={`flex w-full items-center justify-between gap-3 rounded-lg border px-3 py-2.5 text-left transition-colors duration-150 ease-out ${izbran === i ? 'border-green-300 bg-green-50' : 'border-line bg-white hover:bg-canvas'}`} data-id="element-1313" data-mp="csdthcy870uy" data-mpi={i}>
                  <span data-id="element-1314" data-mp="7tsqj5rla32t">
                    <span className="block text-sm font-medium text-ink" data-id="element-1315" data-mp="7qwr1d03f6c9">{p.ime}</span>
                    <span className="block text-xs text-ink-muted" data-id="element-1316" data-mp="3puskye02ybc">{p.opis}</span>
                  </span>
                  <span className={`h-4 w-4 shrink-0 rounded-full border-[5px] ${izbran === i ? 'border-green-500 bg-white' : 'border-line bg-white'}`} data-id="element-1317" data-mp="1j6d2ogwvh83z" />
                </button>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}